import { Button } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { Column, Row } from '@/components/Grid';
import { PageHeading } from '@/components/PageHeading';
import { WithGap } from '@/components/WithGap';
import { appConfig } from '@/constants/config';
import { useTexts } from '@/hooks/useTexts';
import { getBasename } from '@/routes/utils/getBasename';
import { TrackingElement, useGetTrackId } from '@/tracking';

export const InvitationalLinkSuccessPage: FC = () => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();
  const redirectUri = `${window.location.origin}${getBasename()}/`;

  return (
    <Center data-test="invitation-success-page">
      <Page>
        <StyledRow>
          <Column $span={4}>
            <WithGap gap="24">
              <PageHeading header={texts.pages.newuser.success.title} />

              <div className="font-body-large">
                {texts.pages.newuser.success.description}
              </div>

              <div>
                <Button
                  as="a"
                  href={redirectUri}
                  iconRight="arrow_right"
                  data-test="go-to-connect"
                  data-trackid={getTrackId(
                    'go-to-connect',
                    TrackingElement.Link,
                  )}
                >
                  {texts.pages.newuser.success.goToConnect}
                </Button>
              </div>
            </WithGap>
          </Column>
          <StyledColumn $span={8}>
            <ImgWrapper>
              <img
                alt="Start up one person illustration"
                src={`${window.config.storeblocksAssetsBaseUrl}/illustrations/start-up-one-person.svg`}
              />
            </ImgWrapper>
          </StyledColumn>
        </StyledRow>
      </Page>
    </Center>
  );
};

const Center = styled.div`
  max-width: ${appConfig.maxPageWidth};
  margin: 0 auto;
`;

const Page = styled.div`
  margin-top: 72px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 24px;
`;

const StyledRow = styled(Row)`
  margin-top: 8px;
`;

const StyledColumn = styled(Column)`
  display: flex;
  justify-content: center;
`;

const ImgWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  max-height: 500px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
